 document.addEventListener("DOMContentLoaded", function() {
  var lazyloadImages = Array.from(document.querySelectorAll("img.yy-lazyload"));  
  var lazyloadThrottleTimeout;
    
	
    function loadnow () {
       lazyloadImages.forEach(function(img) {           
              img.src = img.dataset.src;
              img.classList.remove('yy-lazyload');          
        });
    }  
    
  function lazyload () {
    if(lazyloadThrottleTimeout) {
      clearTimeout(lazyloadThrottleTimeout);
    }    
    
    lazyloadThrottleTimeout = setTimeout(function() {
        lazyloadImages.forEach(function(img) {           
              img.src = img.dataset.src;
              img.classList.remove('yy-lazyload');          
        });
        if(lazyloadImages.length == 0) { 
          document.removeEventListener("scroll", lazyload);
          window.removeEventListener("orientationChange", lazyload);
        }
    }, 200);
  }
    
    
    function detectmob() { 
 if( navigator.userAgent.match(/Android/i)
 || navigator.userAgent.match(/webOS/i)
 || navigator.userAgent.match(/iPhone/i)
 || navigator.userAgent.match(/iPad/i)
 || navigator.userAgent.match(/iPod/i)
 || navigator.userAgent.match(/BlackBerry/i)
 || navigator.userAgent.match(/Windows Phone/i)
 )
 {return true;} else {return false;}
}
    
     
   if (detectmob())    
   {   
  document.addEventListener("scroll", lazyload);
  window.addEventListener("orientationChange", lazyload);
   }
    else { loadnow(); }  
});